import { render, staticRenderFns } from "./CalculadoraFooter.vue?vue&type=template&id=592b62bf&scoped=true"
import script from "./CalculadoraFooter.vue?vue&type=script&lang=ts"
export * from "./CalculadoraFooter.vue?vue&type=script&lang=ts"
import style0 from "./CalculadoraFooter.vue?vue&type=style&index=0&id=592b62bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592b62bf",
  null
  
)

export default component.exports